import { render, staticRenderFns } from "./store-cate-form.vue?vue&type=template&id=ab79529a"
import script from "./store-cate-form.vue?vue&type=script&lang=js"
export * from "./store-cate-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports